<style lang="less" scoped>
.treeview-contain {
  /deep/ .v-treeview-node__root:hover {
    color: #1867c0 !important;
    caret-color: #1867c0 !important;
    background: #e7edf7;
  }
  .vuetify-disabled {
    color: #BDBDBD;
    text-decoration:line-through;  
  }
} 
</style>
<template>
  <div class="treeview-contain">
    <v-treeview
      open-all
      :hoverable="true"
      :items="propsParams.treeList"
      :loading-icon="'$loading'"
    >
      <template v-slot:label="{ item }">
        <span
          :class="{
            'vuetify-disabled':item.del
          }"
        >{{ item.full_name }}</span>
      </template>
      <template v-slot:append="{ item }">
        <v-btn
          v-if="(item.level===undefined||item.level<propsParams.treeMaxLevel)&&!item.del"
          depressed
          x-small
          dark
          color="primary"
          @click="addNew(item)"
        >
          新增
        </v-btn>
        <v-btn
          v-if="item&&!item.del&&(item.level!==undefined)"
          style="margin-left:10px"
          depressed
          x-small
          dark
          color="primary"
          @click="edit(item)"
        >
          编辑
        </v-btn>
        <v-btn
          v-if="item&&(item.level!==undefined)"
          style="margin-left:10px"
          depressed
          x-small
          dark
          :color="item.del?'primary':'warning'"
          @click="disabled(item)"
        >
          {{ item.del?'启用':'废弃' }}
        </v-btn>
      </template>
    </v-treeview>
    <EditModal 
      ref="addEditModal"
      :field-name="propsParams.editModalField"
      :loading="propsParams.saveLoading"
      :enter-submit="propsParams.enterSubmit"
      :tree-list="propsParams.treeList"
      :need-tree-list="true"
      @ok="save"
    />
    <CommonModal
      ref="commonModal"
      :loading="propsParams.changeStatusLoading"
      @ok="setStatus"
    />
  </div>
</template> 
<script>
  import EditModal from './EditModal'
  import CommonModal from './CommonModal'
  export default {
    components: {
      EditModal,
      CommonModal
    },
    props: {
      propsParams:{
        type:Object,
        default:() => ({})
      }
    },
    data() {
      return {}
    },
    methods: {
      addNew(item) {
        const params = {
          parent_id:item.id,
          name: ''
        }
        this.$refs.addEditModal.show(params)
      },
      edit(item) {
        const params = {
          id:item.id,
          name: item.name,
          parent_id: item.parent_id
        }
        this.$refs.addEditModal.show(params)
      },
      disabled(item) {
        this.$refs.commonModal.show({ props:item, title:item.del ? '确定启用？' : '确定废弃？'})
      },
      setStatus({id}) {
        this.propsParams.changeStatus({id, success:() => {
          this.$refs.commonModal.cancel()
        }})
      },
      save({id, name, parent_id, success} = {}) {
        this.propsParams.addAndEdit({id, name, parent_id, success})
      }
    }
  }
</script>
